import { Route, Switch } from 'react-router';
import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ProgressiveLoadingBlock } from '@bingads-webui-campaign-react/shell-ui-common';
import { ContentFooter } from '@bingads-webui-campaign-react/content-footer';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import {
  StyledOverviewPage,
  StyledAssignmentPage,
  StyledSetupPage,
  StyledFeedUploadPage,
  StyledCalloutExtensionsPage,
  StyledBookingReportPage,
  StyledShareOfVoicePage,
  StyledFeedStatusPage,
  StyledMatchReportPage,
} from './page';

// eslint-disable-next-line
import { bootstrapHotelCenter } from '@bingads-webui-campaign-legacy/hotel-center/bootstrap/bootstrap-ui-next';
// eslint-disable-next-line
import { HotelCenterUploadedReconReport } from '@bingads-webui-campaign-react/hotel-center-uploaded-recon-report-page';
// eslint-disable-next-line
import { HotelCenterProcessedReconReport } from '@bingads-webui-campaign-react/hotel-center-processed-recon-report-page';

export const getHotelCenterShellStyles = () => ({
  contentFooter: {
    display: 'flex',
    flexDirection: 'column-reverse',
    width: '100%',
    position: 'static',
    marginTop: 'auto',
    minWidth: '1032px',
  },
});
class UnStyledHotelCenter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedSubaccountId: 'selectAllSubAccount',
    };
    const { permissions } = props;
    this.isHotelCenterDeprecation = permissions && permissions.dynamic.HotelCenterDeprecation;

    if ($('.visible-element .summary-bar-breadcrumb+.summary-bar-divider')) {
      $('.visible-element .summary-bar-breadcrumb+.summary-bar-divider').addClass('hide');
    }

    this.ReactView = React.lazy(() => bootstrapHotelCenter().then((results) => {
      if (results && results.isHotelAdsDBPilotEnabled === false) {
        return {
          default: () => (
            <div className="alert alert-warning not-in-pilot">
              <I18nContext.Consumer>
                {i18n => (
                  <div className="alert-icon warning">
                    {i18n.getString(_TL_('This account is currently being set up to support Lodging campaigns. Please contact your account manager or msalodgingsolutions@microsoft.com.'))}
                  </div>
                )}
              </I18nContext.Consumer>
            </div>),
        };
      }

      if (results && results.isHotelAdsDBPilotEnabled && results.isPageReady) {
        if (results.pageId === 'setup' && props && props.history) {
          props.history.push({
            pathname: '/campaign/vnext/hotelcenter/setup',
            search: props.history.location.search,
          });
        }
        return ({
          default: () => (
            <Switch>
              <Route
                path="/campaign/vnext/hotelcenter/overview/hotelsubaccountgrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelSubAccountGrid"
                    key="HotelSubAccountGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/hotelidgrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelIdGrid"
                    key="HotelIdGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />)}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/hotelgroupgrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelGroupGrid"
                    key="HotelGroupGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/advancedbookinggrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="AdvancedBookingGrid"
                    key="AdvancedBookingGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/checkindaygrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="CheckinDayGrid"
                    key="CheckinDayGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/hoteldategrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelDateGrid"
                    key="HotelDateGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/datetypegrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="DateTypeGrid"
                    key="DateTypeGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/hoteldevicetypegrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelDeviceTypeGrid"
                    key="HotelDeviceTypeGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/hotelcountrygrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelCountryGrid"
                    key="HotelCountryGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/hotellengthofstaygrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelLengthOfStayGrid"
                    key="HotelLengthOfStayGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/sitetypegrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="SiteTypeGrid"
                    key="SiteTypeGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/hotelslottypegrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelSlotTypeGrid"
                    key="HotelSlotTypeGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview/hotelusercountrygrid"
                render={() => (
                  <StyledOverviewPage
                    gridName="HotelUserCountryGrid"
                    key="HotelUserCountryGrid"
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter/assignment"
                render={() => <StyledAssignmentPage {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/setup"
                render={() => <StyledSetupPage {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/feedupload"
                render={() => <StyledFeedUploadPage {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/matchreport"
                render={() => <StyledMatchReportPage {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/feedstatus"
                render={() => <StyledFeedStatusPage {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/bookingreport"
                render={() => <StyledBookingReportPage {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/sharedofvoice"
                render={() => <StyledShareOfVoicePage {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/calloutextensions"
                render={() => <StyledCalloutExtensionsPage {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/uploadedreconreports"
                render={() => <HotelCenterUploadedReconReport {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/processedreconreports"
                render={() => <HotelCenterProcessedReconReport {...props} />}
              />
              <Route
                path="/campaign/vnext/hotelcenter/overview"
                render={() => (
                  <StyledOverviewPage
                    gridName={this.isHotelCenterDeprecation ? 'HotelIdGrid' : 'HotelSubAccountGrid'}
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
              <Route
                path="/campaign/vnext/hotelcenter"
                render={() => (
                  <StyledOverviewPage
                    gridName={this.isHotelCenterDeprecation ? 'HotelIdGrid' : 'HotelSubAccountGrid'}
                    selectedSubaccountId={this.state.selectedSubaccountId}
                    updateSelectedSubaccount={this.updateSelectedSubaccount}
                    {...props}
                  />
                )}
              />
            </Switch>
          ),
        });
      }

      return { default: () => null };
    }));
  }

  updateSelectedSubaccount = (selectedSubaccountId) => {
    this.setState({
      selectedSubaccountId,
    });
  };

  getBannerMessage = (i18n) => {
    const getLodgingCampaignLink = text => <a href="https://help.ads.microsoft.com/#apex/ads/en/60154/1" target="_blank">{text}</a>
    const getReadmoreLink = text => <a href="https://about.ads.microsoft.com/en-us/blog/post/january-2024/upcoming-changes-to-hotel-center-subaccounts" target="_blank">{text}</a>

    return (
      <>
        <ReactTemplate
          model={{ Link: getLodgingCampaignLink, readmoreLink: getReadmoreLink }}
          template={i18n.getString(_TL_('As of April 9th, you’ll no longer have full access to Hotel Center for your campaign management. You can continue to manage your feeds through Hotel Center; otherwise, please use {{Link}}Lodging campaigns{{/Link}} to manage your Hotel Price ads and Property Promotion ads. {{readmoreLink}}Read more about how you can make your migration process smoother.{{/readmoreLink}}'))}
        />
      </>
    )
  };

  render() {
    return (
      <React.Suspense fallback={<ProgressiveLoadingBlock />}>
        <I18nContext.Consumer>
          {i18n => (
            <MessageBar
              messageBarType={MessageBarType.error}
              isMultiline
              onDismiss={null}
              messageBarIconProps={{
                iconName: 'info',
                style: {
                  color: '#d83b01',
                },
              }}
            >
              {this.getBannerMessage(i18n)}
            </MessageBar>
          )}
        </I18nContext.Consumer>
        <this.ReactView />
        {this.props.history.location.pathname.includes('overview') ? null : (
          <div className={this.props.classes.contentFooter}>
            <ContentFooter />
          </div>)
        }
      </React.Suspense>);
  }
}

UnStyledHotelCenter.propTypes = {
  classes: PropTypes.shape({
    contentFooter: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
    }),
  }).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({}),
  }).isRequired,
};

export const StyledHotelCenter = withDefaultStyles(UnStyledHotelCenter, getHotelCenterShellStyles);
